export const Constants = {
  level: 'Nível ',
  advertiser: 'nome anunciante',
  advertiserContact: 'contato anunciante',
  privateArea: 'área privativa',
  landArea: 'área do terreno',
  constructedArea: 'área construída:',
  squareMeters: ' m²',
  parkingLots: 'vagas de garagem',
  propertyType: 'tipo de imóvel',
  cep: 'CEP',
  city: 'cidade',
  district: 'bairro',
  address: 'logradouro',
  number: 'número',
  sellingPrice: 'preço de venda',
  real: 'R$ ',
  rentingPrice: 'preço do aluguel',
  condominiumValue: 'valor do condomínio',
  propertyLink: 'link do imóvel',
  showMap: 'Mostrar mapa',
  estimateConservation: 'calcular estado de conservação',
  approve: 'aprovar',
  desapprove: 'desaprovar',
  remove: 'excluir elemento',
  deleteText: 'excluir este elemento',
  pictures: 'Fotos',
  edit: 'editar',
  editConfirm: 'editar / confirmar',
  search: 'buscar',
  cancel: 'cancelar',
  save: 'salvar',
  reportError: 'reportar erro',
  reason: 'Motivo',
  send: 'enviar',
  update: 'atualizar',
  lat: 'latitude:',
  lng: 'longitude:',
  searchMap: 'pesquisar no mapa',
  mapUpdated: 'mapa atualizado',
  fieldsIncomplete: 'Preencha os campos obrigatórios do endereço',
  acceptCheck:
    'Estou ciente que sou responsável pelos dados acima e os declaro como verdadeiros.',
  reportErrorReason: 'Escreva aqui o motivo do erro reportado',
  propertyDescription: 'Descrição do imóvel',
  movePin: 'Mova o pin e salve caso a localização esteja incorreta',
  downloadPdf: 'download site pdf',
};

export const PropertyDescription =
  // eslint-disable-next-line max-len
  'Descubra o ápice do luxo urbano nesta magnífica cobertura duplex localizada no prestigioso bairro do Jardins, na deslumbrante cidade de São Paulo. Com seus impressionantes 780m², esta residência é verdadeiramente uma obra-prima da arquitetura contemporânea. Composta por 4 suítes exuberantes, incluindo uma super master com um espaçoso closet e elegantes armários Ornare, esta cobertura duplex oferece o mais alto nível de conforto e privacidade. Além disso, um escritório funcional permite que você trabalhe com tranquilidade sem sair do conforto de sua casa. A cozinha planejada, com seus requintados armários, é um convite para os amantes da culinária experimentarem pratos incríveis. A espaçosa sala com 3 ambientes inclui um home theater para momentos de entretenimento, uma sala de jantar onde memórias gastronômicas serão criadas e uma sala de estar aconchegante para relaxar e receber convidados. Um lavabo adiciona um toque de sofisticação extra. Para os chefes de cozinha mais exigentes, a cozinha gourmet equipada com os renomados e elegantes equipamentos Viking proporcionará uma experiência culinária incomparável. Cada detalhe foi cuidadosamente selecionado para criar uma atmosfera de luxo e requinte. Esta cobertura duplex no bairro do Jardins é a personificação do estilo de vida sofisticado e exclusivo que São Paulo tem a oferecer. Não perca a oportunidade de adquirir esta joia imobiliária. Agende uma visita agora mesmo e deixe-se encantar pelo esplendor desta residência única.';
